<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div
        class="result-table list-content"
        style="width: 100%; scrollbar-width: none; -ms-overflow-style: none;"
    >
        <vue3-datatable
            v-if="tripItems && tripItems.length > 0"
            ref="resultTable"
            :rows="tripItems"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="tripItems.length > 7 ? '47.5em' : '100%'"
            :sortable="true"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
            <template #duration="data">
                {{ getWorkTime(data.value.duration) }}
            </template>
        </vue3-datatable>
    </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils.js";
import {vehicleHelper} from "@/components/mixins/VehicleMixin.js";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'FuelReportList',
    components: {Vue3Datatable},
    mixins: [timeUtils, vehicleHelper],
    props: {
        fuelReports: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            selectedRowId: null,
            loading: 0,
            tripItems: []
        }
    },
    computed: {
        fields() {
            return [
                {
                    field: 'vehicle',
                    title: this.$t('trip_list.vehicle'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'company',
                    title: this.$t('users.company'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'fuelType',
                    title: this.$t('trip_list.fuel_type'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'duration',
                    title: this.$t('trip_list.duration'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'distance',
                    title: this.$t('work_report.distance'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'liters',
                    title: this.$t('trip_list.liters'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                }
            ]
        },
    },
    watch: {
        fuelReports() {
            this.initTableItems()
        }
    },
    methods: {
        initTableItems() {
            this.tripItems = []
            const temp = this.fuelReports.map((report, index) => {
                return {
                    id: index,
                    vehicle: report.vehicle?.name || report.vehicle,
                    company: report.company ||  '-',
                    fuelType: this.getFuelTypeName(report.vehicle.fuel_type) || '-',
                    duration: report.total_minutes,
                    distance: report.total_distance,
                    liters: report.total_liters
                }
            })
            this.$nextTick(() => this.tripItems = temp)
        }
    }
}
</script>
<style>
</style>
